import { Card, Col, Container, Row } from "react-bootstrap";
import Header from "../../components/common/Header";
import themealdb from "../../themealdb.png";
import { icons } from "../../components/common/Icons";
import { Link } from "react-router-dom";

function ProviderList() {
    return (
        <Container>
            <Header>Providers</Header>
            <Row>
                <Col>
                    <Card>
                        <Card.Header>
                            <Card.Title>The Meal DB</Card.Title>
                        </Card.Header>
                        <Card.Body className="text-center" style={{backgroundColor: '#1e1b17'}}>
                            <Link to={'/providers/mealdb'}>
                                <img
                                    width="100%" 
                                    src={themealdb}
                                    alt="TheMealDB"
                                />
                            </Link>
                        </Card.Body>
                        <Card.Footer>
                            <a href="https://www.themealdb.com/" target="_blank" rel="noreferrer">Website <>{icons.icon('box-arrow-right')}</></a>
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}

export default ProviderList;